// Copyright (c) 2021 Davide Gironi
// Please refer to LICENSE file for licensing information.

import ConfigSecrets from "./configsecrets";

let config = {};

config.languages = ['en'];
config.contacts = {};
config.contacts.emailservicetoken = ConfigSecrets.emailservicetoken;

//load override configs
let configload = {};
// eslint-disable-next-line no-undef
if (process.env.REACT_APP_ENV === "development") {
    configload = {
    };
    // eslint-disable-next-line no-undef
} else if (process.env.REACT_APP_ENV === "production") {
    configload = {
    };
    // eslint-disable-next-line no-undef
} else if (process.env.REACT_APP_ENV === "testing") {
    configload = {
    };
}

//override configs
config = { ...config, ...configload };

export default config;
